export class ObjectUtils {


    static isEmpty<V>(record: Record<string, V> | undefined | number): boolean {
        if (!record) {
            return true;
        }
        return Object.keys(record).length === 0;
    }

    static deleteKey<T extends Record<string, any>, K extends keyof T>(obj: T, key: K): Omit<T, K> {
        const {[key]: deletedKey, ...rest} = obj;
        return rest;
    }

    static convertObjectToArray<T extends Record<string | number,any>>(obj:T){
        return obj ? Object.keys(obj).map((key) =>obj[key]):[];
    }
}